const BREADCRUMB_HISTORY_KEY = 'gillian-breadcrumb-history-v1';
const MAX_BREADCRUMB_HISTORY = 12;

class SiteBreadcrumbs extends HTMLElement {
  connectedCallback() {
    const records = this.#readHistory();
    const current = this.#currentRecord();
    const previous = this.#previousRecord(records, current.path);

    this.#enhanceProductContext(previous);
    this.#enhanceBackLink(previous);
    this.#storeCurrent(records, current);
  }

  #currentRecord() {
    return {
      type: this.dataset.pageType || '',
      title: this.dataset.pageTitle || document.title,
      path: `${window.location.pathname}${window.location.search}`,
    };
  }

  #readHistory() {
    try {
      const value = JSON.parse(sessionStorage.getItem(BREADCRUMB_HISTORY_KEY) || '[]');
      return Array.isArray(value) ? value.filter((record) => this.#isValidRecord(record)) : [];
    } catch (_error) {
      return [];
    }
  }

  #isValidRecord(record) {
    return Boolean(
      record &&
        typeof record.type === 'string' &&
        typeof record.title === 'string' &&
        typeof record.path === 'string' &&
        record.path.startsWith('/')
    );
  }

  #previousRecord(records, currentPath) {
    for (let index = records.length - 1; index >= 0; index -= 1) {
      if (records[index].path !== currentPath) return records[index];
    }

    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin === window.location.origin && `${referrer.pathname}${referrer.search}` !== currentPath) {
        return {
          type: this.#typeFromPath(referrer.pathname),
          title: 'Previous page',
          path: `${referrer.pathname}${referrer.search}`,
        };
      }
    } catch (_error) {
      // A missing or external referrer should use the Liquid fallback link.
    }

    return null;
  }

  #typeFromPath(pathname) {
    if (pathname.startsWith('/collections/')) return 'collection';
    if (pathname.startsWith('/search')) return 'search';
    if (pathname.startsWith('/products/')) return 'product';
    if (pathname === '/') return 'index';
    return 'page';
  }

  #enhanceProductContext(previous) {
    if (this.dataset.pageType !== 'product' || !previous) return;
    if (!['collection', 'search', 'list-collections'].includes(previous.type)) return;

    const contextLink = this.querySelector('[data-breadcrumb-context-link]');
    if (!contextLink) return;

    contextLink.href = previous.path;
    contextLink.textContent = previous.title;
  }

  #enhanceBackLink(previous) {
    const backLink = this.querySelector('[data-breadcrumb-back]');
    if (!backLink || !previous) return;

    backLink.href = previous.path;
    backLink.setAttribute('aria-label', `Back to ${previous.title}`);
  }

  #storeCurrent(records, current) {
    const lastRecord = records.at(-1);
    if (lastRecord?.path === current.path) {
      records[records.length - 1] = current;
    } else {
      records.push(current);
    }

    try {
      sessionStorage.setItem(
        BREADCRUMB_HISTORY_KEY,
        JSON.stringify(records.slice(-MAX_BREADCRUMB_HISTORY))
      );
    } catch (_error) {
      // Breadcrumb links still work from their Liquid fallbacks without storage.
    }
  }
}

if (!customElements.get('site-breadcrumbs')) {
  customElements.define('site-breadcrumbs', SiteBreadcrumbs);
}

